module.exports = __webpack_public_path__ + "img/ai_vip_bg.e4c0d9af.png";